/** Small display helpers. Pure functions, so they are cheap to test. */

/** 214000 → "3:34". Null for anything we do not have a length for. */
export function duration(ms) {
  if (typeof ms !== 'number' || !Number.isFinite(ms) || ms <= 0) return null
  const total = Math.round(ms / 1000)
  const minutes = Math.floor(total / 60)
  const seconds = total % 60
  return `${minutes}:${String(seconds).padStart(2, '0')}`
}

/**
 * The noun for a count: `plural(1, 'track')` → "track", `plural(2, 'track')` →
 * "tracks". Returns the noun and not the phrase, so the number stays in the
 * element and the sentence position its author put it in.
 */
export function plural(n, one, many = `${one}s`) {
  return n === 1 ? one : many
}

/** The line under an album title: type, year, and how many tracks. */
export function albumFacts({ primary_type, year, tracks = [] }) {
  return [
    primary_type,
    year ? String(year) : null,
    tracks.length ? `${tracks.length} ${plural(tracks.length, 'track')}` : null,
  ]
    .filter(Boolean)
    .join(' · ')
}
